<template>
  <a-modal
      title="调出申请"
      :visible="visible"
      :width="600"
      @ok="handleOk"
      @cancel="handleCancel">
    <a-form-model
        ref="targetForm"
        :model="form"
        :rules="rules"
        :label-col="{span: 8}"
        :wrapper-col="{span: 14}"
    >
      <a-row class="form-row">
        <a-col :lg="24" :md="24" :sm="24">
          <a-form-model-item label="护照" prop="passportNumber">
            <a-input placeholder="例如 EB8195***" v-model="form.passportNumber"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>


import {HttpMixins} from "@/mixins/http-mixins";

const pattern = {
  passportNumber: /^([A-Z]|[0-9]){5,17}$/,
}

export default {
  name: "CreateSearchModal",
  mixins: [HttpMixins],
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        passportNumber: [{required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'}],
      },
      url: {
        search: window._CONFIG['domainURL'] + "/power/usDs/search",
      }
    }
  },
  methods: {
    show(authority) {
      this.visible = true;
      this.form = {
        authority: authority
      };
    },
    handleOk() {
      let that = this;
      const handleSuccess = (res) => {
        if (res) {
          let data = res.data;
          if (!data) {
            that.$message.error("没有查到存档");
            return;
          }
          that.$message.success("成功调出最新存档");
          that.$emit('ok', data);
          that.handleCancel();
        }
      };
      this.$refs.targetForm.validate(valid => {
        if (valid) {
          that.$axios.get(that.url.search + "?authority=" + that.form.authority + "&passportNumber=" + that.form.passportNumber)
              .then(handleSuccess)
              .catch((error) => that.catchError(error).then(handleSuccess));
        }
      });
    },
    handleCancel() {
      this.visible = false;
    }
  }
}
</script>

<style scoped>

</style>
